import { container } from '@shared/common/dependency-injection/domain/container';
import type { RouteLocationNormalized } from 'vue-router';
import { GameDetailDependencyTypes } from '@client/feature/game-detail/game-detail.dependency-types';
import type { GameKind } from '@client/entity/game/common/core/domain/constant/game-kind.constant';
import type { GameDetailFetcherService } from '@client/feature/game-detail/domain/service/game-detail-fetcher.service';

export async function checkGameDetailIsFetched(to: RouteLocationNormalized) {
  const gameDetailFetcherService = container.get<GameDetailFetcherService>(
    GameDetailDependencyTypes.GameDetailFetcherService,
  );
  const gameId = to.params.gameId as string;
  const gameKind = to.params.gameKind as GameKind;

  return gameDetailFetcherService.ensureGameDetailIsFetched(gameId, gameKind);
}
